import { QueryClient } from '@tanstack/react-query';

/** Default stale window for server state — reduces refetch churn on navigation. */
const DEFAULT_STALE_TIME_MS = 30_000;

/** Inactive query garbage collection (TanStack Query v5 default). */
const DEFAULT_GC_TIME_MS = 5 * 60 * 1000;

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: DEFAULT_STALE_TIME_MS,
        gcTime: DEFAULT_GC_TIME_MS,
        retry: 1,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
      },
    },
  });
}
